import { PaymentProvider } from '@src/@data/types/paymentProviders';

export const defaultCalendarsSort = (
  c1: { title: string; id: string },
  c2: { title: string; id: string }
): number => {
  let result = c1.title.localeCompare(c2.title, undefined, { numeric: true });
  if (result === 0) {
    result = c1.id.localeCompare(c2.id);
  }
  return result;
};

export const hasOnlinePayments = (
  paymentProviders?: PaymentProvider[]
): boolean => {
  if (!paymentProviders) {
    return false;
  }
  return (
    paymentProviders.includes(PaymentProvider.Stripe) ||
    paymentProviders.includes(PaymentProvider.InternetBank)
  );
};
